module.exports = __webpack_public_path__ + "img/thumbnail_Jaguar_j_normal.ed97e1e6.png";